import { useContext } from 'react';
import { AuthenticatedContext } from 'market-frontend-web/src/contexts/AuthenticatedContext';

const useAuthIsHydrated = (): boolean => {
  const authContext = useContext(AuthenticatedContext);

  return authContext.authIsHydrated;
};

export default useAuthIsHydrated;
